import { API_LOBBY } from '../baseUrls';
import { baseApiPost } from '../baseApi';

export const lobbyApiPost = ({ params }) => {
  return baseApiPost({ api: API_LOBBY, params });
};
